import React from "react";

const SettingsPreferencesCard = ({title, subtitle, more, contentInput}: {
    title: string;
    subtitle?: string;
    more?: string | React.ReactNode;
    contentInput: React.ReactNode
}): React.ReactElement => {

    return (
        <div className={"p-16 mx-16 mb-16 radius-4 bg--surface-page"}>
            <h3>{title}</h3>
            <h4 className={"mb-8"}>{subtitle}</h4>
            {contentInput}
            <div>{more}</div>
        </div>
    )
};

export default SettingsPreferencesCard;